import clsx from 'clsx';
import React, { Activity, MouseEventHandler } from 'react';
import { IButtonStyle } from '../../interface/interface';
import { SemanticColor, type TColorVarsMap, toColorVars } from '../../theme/colors';
import { getInlineStyles } from '../../utils/styles';
import { VisualView } from '../Image/VisualView';
import styles from './styles/buttonFlat.module.css';

type TButtonFlatProps = {
    label?: string;
    iconName?: string;
    onClick?: MouseEventHandler;
    /** Design version of the widget it renders for (`TWidget.version`): picks semantic colors and icons. */
    version: number | undefined;
} & IButtonStyle;

/** Colors read by `buttonFlat.module.css`. */
const BUTTON_FLAT_COLOR_VARS = {
    '--button-flat-text': SemanticColor.TextEmphasised,
    '--button-flat-text-disabled': SemanticColor.TextEmphasisedDisabled,
    '--button-flat-bg': SemanticColor.FillSecondary,
    '--button-flat-bg-hovered': SemanticColor.FillGhostHovered,
    '--button-flat-bg-pressed': SemanticColor.FillGhostPressed,
} as const satisfies TColorVarsMap;

export const ButtonFlat = (props: TButtonFlatProps) => {
    return (
        <Activity mode={props.isHide ? 'hidden' : 'visible'}>
            <button
                className={clsx(styles.floatButton, props.isDisabled && styles.floatButtonDisabled)}
                onClick={props.onClick}
                style={{
                    ...getInlineStyles({
                        margin: {
                            top: props.marginTop,
                            bottom: props.marginBottom,
                            left: props.marginLeft,
                            right: props.marginRight,
                        },
                    }),
                    ...toColorVars(BUTTON_FLAT_COLOR_VARS, props.version),
                }}
            >
                <VisualView
                    version={props.version}
                    iconVariant={'circle'}
                    iconHierarchy={'primary'}
                    iconName={props.iconName}
                    isDisabled={props.isDisabled}
                    margin={{ bottom: 8 }}
                />
                {props.label}
            </button>
        </Activity>
    );
};
